import {FileIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import styles from './ConflictingFilesList.module.css'

/**
 * Renders the list of conflicting file paths for a pull request.
 */
export function ConflictingFilesList({conflicts, className}: {conflicts: string[]; className?: string}) {
  if (conflicts.length === 0) return null

  return (
    <div className={className}>
      <ActionList className="py-0 overflow-hidden">
        {conflicts.map(conflictPath => (
          <ActionList.Item key={conflictPath}>
            <ActionList.LeadingVisual className="fgColor-muted">
              <FileIcon />
            </ActionList.LeadingVisual>
            <span className={`input-monospace f6 ${styles.selectable}`}>{conflictPath}</span>
          </ActionList.Item>
        ))}
      </ActionList>
    </div>
  )
}
